import React from 'react';
import { Loader2 } from 'lucide-react';

export function LoadingSpinner({ text = 'Memuat...', size = 'default' }) {
  const sizeClasses = {
    small: 'h-4 w-4',
    default: 'h-6 w-6',
    large: 'h-8 w-8'
  };

  return (
    <div className="flex flex-col items-center justify-center py-8 space-y-3">
      <Loader2 className={`${sizeClasses[size]} text-primary animate-spin`} />
      {text && (
        <p className="text-xs text-muted-foreground">{text}</p>
      )}
    </div>
  );
}

// Inline loading spinner untuk buttons
export function InlineSpinner({ className = '' }) {
  return <Loader2 className={`h-4 w-4 animate-spin ${className}`} />;
}